import { toast } from 'react-toastify';
import { DASHBOARD_PANTALLA_API } from '../views/MainLayout/components/shared/services/dashboardPantalla.js';

const initialDashboard = {
    cards: {
        incidencias: 0,
        incidencias_tiempo: '',
        incidencias_experiencia: 0,
        presupuestos_semana: 0,
        presupuestos_hoy: 0,
        presupuestos_mes: 0,
        pieza_no_encontrada: 0,
        record_semana: {
            fecha: '',
            total: 0,
        },
        record_dia: {
            fecha: '',
            total: 0,
        },
        record_mes: {
            fecha: '',
            total: 0,
        },
    },
    summary: [],
    isLoading: false,
};

export const dashboardPantallaReducer = (state = initialDashboard, action) => {
    switch (action.type) {
        case 'dashboard-pantalla/fullfilled': {
            return {
                ...state,
                ...action.payload,
            };
        }
        case 'dashboard-pantalla/refresh': {
            const { cards: newCards, summary } = action.payload;
            const updatedCards = { ...state.cards, ...newCards };

            const today = new Date();

            if (newCards.presupuestos_hoy > state.cards.record_dia.total) {
                const formattedToday =
                    today.getDate().toString().padStart(2, '0') +
                    '/' +
                    (today.getMonth() + 1).toString().padStart(2, '0') +
                    '/' +
                    today.getFullYear();
                updatedCards.record_dia = {
                    fecha: formattedToday,
                    total: newCards.presupuestos_hoy,
                };
            }

            if (
                newCards.presupuestos_semana > state.cards.record_semana.total
            ) {
                const weekStart = new Date(today);
                weekStart.setDate(today.getDate() - today.getDay() + 1);
                const weekEnd = new Date(today);
                weekEnd.setDate(today.getDate() - today.getDay() + 7);

                const format = (d) =>
                    d.getDate().toString().padStart(2, '0') +
                    '/' +
                    (d.getMonth() + 1).toString().padStart(2, '0');

                updatedCards.record_semana = {
                    fecha: `${format(weekStart)}-${format(
                        weekEnd
                    )}/${weekEnd.getFullYear()}`,
                    total: newCards.presupuestos_semana,
                };
            }

            if (newCards.presupuestos_mes > state.cards.record_mes.total) {
                const month = (today.getMonth() + 1)
                    .toString()
                    .padStart(2, '0');
                const year = today.getFullYear();
                updatedCards.record_mes = {
                    fecha: `${month}/${year}`,
                    total: newCards.presupuestos_mes,
                };
            }

            return {
                ...state,
                cards: updatedCards,
                summary,
            };
        }
        case 'dashboard-pantalla/loading': {
            return {
                ...state,
                isLoading: action.payload,
            };
        }
        default:
            return state;
    }
};

export const fetchDashboardPantalla = () => async (dispatch) => {
    dispatch({ type: 'dashboard-pantalla/loading', payload: true });
    try {
        const response = await DASHBOARD_PANTALLA_API.get();
        const data = await response.data;
        dispatch({ type: 'dashboard-pantalla/fullfilled', payload: data });
    } catch (e) {
        toast.error(e.message);
    } finally {
        dispatch({ type: 'dashboard-pantalla/loading', payload: false });
    }
};

export const fetchRefreshDashboardPantalla = () => async (dispatch) => {
    try {
        const response = await DASHBOARD_PANTALLA_API.refresh();
        const data = await response.data;
        dispatch({ type: 'dashboard-pantalla/refresh', payload: data });
    } catch (e) {
        toast.error(e.message);
    }
};
